import React, { Component } from "react";
import {
  Card,
  WhiteSpace,
  ActivityIndicator,
  Flex,
  Modal,
  Toast,
} from "antd-mobile";
import { get, map, isEmpty } from "lodash";
import moment from "moment";
import VideoPlayer from "./videoPlayer";
import Correlation from "./correlation";
import DoesItHelpComponent from "./doesItHelp";
import includes from "lodash/includes";

import { getPatientIdFromUrl, getParams } from "../../../utils";
import { FOLLOW_STATUS_COMMUNITY_MAP } from "../constant";
import SkeletonScreen from "./skeletonScreen";

const postMessage = (msg) => {
  const stringify = JSON.stringify(msg);
  window.postMessage(stringify, "*");
};
// 渲染文章内容
const ContentComponent = ({
  contentHtmlList,
  videoList,
  contentHtml,
  fontSize,
  content,
  blogId,
  patientId,
  sourceType,
  updateVideoAnalysis,
}) => {
  return (
    <div
      class="knowledge"
      style={{ MozUserSelect: "text", WebkitUserSelect: "text" }}
    >
      {(() => {
        if (contentHtml) {
          return contentHtmlList.map((e, i) => {
            if (e) {
              if (fontSize && fontSize !== "16")
                e =
                  `<style>.knowledge p span{ font-size: ${fontSize}px!important;}</style>` +
                  e;
              return (
                <div>
                  <div dangerouslySetInnerHTML={{ __html: e }} />
                  {
                    // 重新渲染原生 video 控件，统一 android 和 ios 的功能与样式
                    videoList[i] ? (
                      <VideoPlayer
                        patientId={patientId}
                        blogId={blogId}
                        sourceType={sourceType}
                        updateVideoAnalysis={updateVideoAnalysis}
                        autoplay={false}
                        controls={true}
                        height={"100%"}
                        sources={[
                          {
                            src: get(videoList[i], "src"),
                            type: "video/mp4",
                          },
                        ]}
                        poster={get(videoList[i], "poster")}
                      />
                    ) : null
                  }
                </div>
              );
            }
          });
        } else {
          return <div>{content}</div>;
        }
      })()}
    </div>
  );
};
class Article extends Component {
  state = {
    showModal: false,
  };
  componentDidMount() {
    const { insertView } = this.props;
    const blogId = get(this.props, "match.params.knowledgeId");
    const patientId = get(this.props, "match.params.patientId");
    const systemType = get(this.props, "match.params.systemType", "BG");
    const isShare = get(this.props, "isShare", true);
    const queryString = get(this.props, "location.search") || "";
    const setObj = {};
    let variables = {};
    queryString
      .replace(/\?/g, "")
      .split("&")
      .forEach((item) => {
        if (item) {
          const splitItems = item.split("=");
          setObj[splitItems[0]] = splitItems[1];
        }
      });
    if (!isShare) {
      variables = {
        blogId,
        systemType,
        patientId,
        ...setObj,
      };
    } else {
      variables = {
        blogId,
        systemType,
        ...setObj,
      };
    }
    const mutate = insertView;
    mutate({ variables })
      .then((res) => {
        console.log("views mutate then", res);
        // const objId =get(res, 'data.insertView')
        // this.setState({id:objId})
        // console.log('views mutate then',objId, this.state)
      })
      .catch((e) => {
        console.log("catch an error", e);
      });
    window.addEventListener("event_send_native_focus", this.handleFocus, false);
  }

  componentDidUpdate() {
    const url = window.location.href;
    const result = url.split("#");
    if (result[1] === "collectionBg") {
      document.getElementById(result[1]) &&
        document.getElementById(result[1]).scrollIntoView(true);
    }
  }
  componentDidUpdate() {
    // 编辑图片
    const isShare = get(this.props, "isShare");
    if (isShare) return;
    const knowledge = document.getElementsByClassName("knowledge");
    if (knowledge.length > 0) {
      const imgList = knowledge[0].getElementsByTagName("img");
      const urlList = [...imgList].map((e) => {
        return e.src;
      });
      for (let i in imgList) {
        if (isFinite(i)) {
          imgList[i].addEventListener("click", function () {
            postMessage({
              index: i,
              imageUrl: urlList,
            });
          });
        }
      }
    }
  }
  gotoAuthorPage(authorId) {
    if (authorId) {
      const players = document.querySelectorAll("video, audio");
      map(players, (player) => {
        player && player.pause();
      });
      postMessage({ type: "clickAuthorName", payload: { authorId } });
    }
  }
  handleFocus = () => {
    console.log("页面获取到了焦点");
    // 处理页面获得焦点的逻辑；从App个人主页返回到 文章页面时，再请求一次最新的关注状态按钮
    if (this.props.getFollowState) {
      this.props.getFollowState.refetch();
    }
  };

  /**
   * 解析获取视频列表
   * @param {*} args
   */
  getVideoList(args) {
    let { content } = args;
    let contentHtmlList = [], // 拆解以后的 html
      videoList = [],
      videoHtmlList = [],
      videoBegin = 0,
      videoEnd = 0;
    while (includes(content, "<video")) {
      videoBegin = content.indexOf("<video");
      videoEnd = content.indexOf("</video>");
      contentHtmlList.push(content.substring(0, videoBegin));
      videoHtmlList.push(content.substring(videoBegin, videoEnd + 8));
      content = content.substring(videoEnd + 8, content.length);
    }
    contentHtmlList.push(content);

    let parser,
      htmlDoc,
      poster = "",
      src = "";

    for (let i = 0; i < videoHtmlList.length; i++) {
      parser = new DOMParser();
      htmlDoc = parser.parseFromString(videoHtmlList[i], "text/html");
      poster =
        htmlDoc.getElementsByTagName("video")[0]["attributes"]["poster"].value;
      src =
        htmlDoc.getElementsByTagName("source")[0]["attributes"]["src"].value;
      videoList.push({ poster, src });
    }
    return { contentHtmlList, videoList };
  }

  needUpdate = (currentVersion, latestVersion) => {
    if (isEmpty(currentVersion) || isEmpty(latestVersion)) return false;
    const version1 = latestVersion.split(".");
    const version2 = currentVersion.split(".");
    while (version1.length || version2.length) {
      const v1 = parseInt(version1.shift()) || 0;
      const v2 = parseInt(version2.shift()) || 0;
      if (v1 > v2) return true;
      if (v2 > v1) return false;
    }
    return false;
  };

  render() {
    const blogs = get(this.props, "blogs");
    const blogId = get(this.props, "match.params.knowledgeId");
    const patientId = getPatientIdFromUrl(this.props);
    const { fontSize, isActivity } = getParams(get(this.props, "match.url"));
    const updateVideoAnalysis = get(this.props, "updateVideoAnalysis");
    const patientState = get(
      this.props,
      "patientQueryById.patient.patientState",
      ""
    );
    const isZhaohuUser = patientState !== "POTENTIAL";
    const followStatus = get(this.props, "getFollowState.getFollowState");
    const mutateSaveFollow = this.props.saveFollow;
    const appVersion = get(
      this.props,
      "appVision.getUserAppVision.appVersion",
      ""
    );

    const isShowFollow = this.needUpdate("2.3.12", appVersion);
    const source = get(this.props, "location.search") || "";
    let sourceType = null;
    if (source.indexOf("&source=") > 0) {
      const index = source.indexOf("&source=");
      sourceType = source.substring(index + 8, source.length);
    } else {
      const index = source.indexOf("=");
      sourceType = source.substring(index + 1, source.length);
    }
    const hasFocus = ["had_follow_other"].includes(followStatus);

    const isShare = get(this.props, "isShare");
    let contentHtmlList = [],
      videoList = [],
      video = "";
    if (!blogs.loading && blogs.blogs) {
      const blog = blogs.blogs[0] || {};
      const content = [];
      let contentHtml = null;
      for (const key in blog.content) {
        if (blog.content.hasOwnProperty(key)) {
          const p = blog.content[key];
          video = this.getVideoList({
            content: p,
          });
          contentHtmlList = get(video, "contentHtmlList"); // 拆分后的 html
          videoList = get(video, "videoList"); // 视频列表
          if (p.indexOf("<p") > -1) {
            contentHtml = {
              __html: p,
            };
          } else {
            content.push(
              <div
                key={"content" + key}
                style={{
                  lineHeight: "20px",
                  color: "RGBA(88, 79, 98, 1)",
                  marginTop: "10px",
                }}
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{p}
              </div>
            );
          }
        }
      }
      return (
        <main>
          <div style={{ overflowX: "hidden", background: "#fff" }}>
            <div
              style={{
                padding: 0,
              }}
            >
              <div
                style={{
                  padding: "0 14px",
                }}
              >
                <div>
                  <h3
                    style={{
                      fontSize: "20px",
                      fontFamily: "PingFang SC,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,Helvetica,Arial,Hiragino Sans GB,Source Han Sans,Noto Sans CJK Sc,Microsoft YaHei,Microsoft Jhenghei,sans-serif,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,Helvetica,Arial,Hiragino Sans GB,Source Han Sans,Noto Sans CJK Sc,Microsoft YaHei,Microsoft Jhenghei,sans-serif",
                    }}
                  >
                    {blog.title}
                  </h3>
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "RGBA(180, 177, 185, 1)",
                    lineHeight: "26px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <a
                      style={{
                        display: "flex",
                        alignContent: "center",
                        color: "#24C6AE",
                      }}
                      onClick={() =>
                        this.gotoAuthorPage(get(blog, "authorInfo.userId", ""))
                      }
                    >
                      <img
                        style={{
                          width: "26px",
                          height: "26px",
                          marginRight: "5px",
                          borderRadius: "13px",
                        }}
                        src={
                          get(
                            blog,
                            "authorInfo.avatar",
                            "https://paper-king.ks3-cn-beijing.ksyun.com/workwechat1551700250094.png"
                          ) ||
                          "https://paper-king.ks3-cn-beijing.ksyun.com/workwechat1551700250094.png"
                        }
                      />
                      <span style={{ wordBreak: "keep-all" }}>
                        {get(blog, "authorInfo.nickname", "")}
                      </span>
                    </a>
                    {isZhaohuUser && isShowFollow && (
                      <a
                        onClick={() => {
                          if (hasFocus) {
                            this.setState({ showModal: true });
                          } else {
                            mutateSaveFollow({
                              variables: {
                                selfId: patientId,
                                blogId,
                                status: true,
                              },
                            })
                              .then((res) => {
                                const ret = get(res, "data.saveFollow", false);
                                if (ret) {
                                  Toast.success("关注成功", 2);
                                  this.props.getFollowState &&
                                    this.props.getFollowState.refetch();
                                } else {
                                  Toast.success("关注失败", 2);
                                }
                              })
                              .catch((e) => {
                                console.log("catch an error", e);
                              });
                          }
                        }}
                        activeOpacity={1}
                        style={{
                          display: "flex",
                          height: "28px",
                          width: hasFocus ? "70px" : "58px",
                          justifyContent: "center",
                          alignItems: "center",
                          borderColor: hasFocus ? "#999" : "#26C5AB",
                          borderStyle: "solid",
                          borderWidth: "1px",
                          borderRadius: "14px",
                          marginLeft: "20px",
                        }}
                      >
                        <div
                          style={{ flexDirection: "row", alignItems: "center" }}
                        >
                          <img
                            src={
                              FOLLOW_STATUS_COMMUNITY_MAP[followStatus] &&
                              FOLLOW_STATUS_COMMUNITY_MAP[followStatus].icon
                            }
                            style={{ width: 8, height: 8, marginRight: 4 }}
                          />
                          <text
                            style={{
                              fontSize: 13,
                              color: hasFocus ? "#999" : "#26C5AB",
                            }}
                          >
                            {get(
                              FOLLOW_STATUS_COMMUNITY_MAP,
                              `${followStatus}.text`,
                              "关注"
                            )}
                          </text>
                        </div>
                      </a>
                    )}
                  </div>
                  <div
                    style={{
                      minWidth: "70px",
                      textAlign: "right",
                      fontFamily: "PingFang SC,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,Helvetica,Arial,Hiragino Sans GB,Source Han Sans,Noto Sans CJK Sc,Microsoft YaHei,Microsoft Jhenghei,sans-serif,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,Helvetica,Arial,Hiragino Sans GB,Source Han Sans,Noto Sans CJK Sc,Microsoft YaHei,Microsoft Jhenghei,sans-serif",
  
                    }}
                  >
                    {moment(blog.publishedAt).format("YYYY-MM-DD")}
                  </div>
                </div>
                {/* <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  marginTop: '10px',
                }}
              >
                <span style={{ marginBottom: '8px' }}>
                  作者|共同照护专业营养医师 张雯霏；责任编辑|谷国青
                </span>
                <span>
                  参考|中国营养膳食指南；全民健身指南；2型糖尿病防治指南
                </span>
              </div> */}
                <WhiteSpace size="lg" />{" "}
                {(() => {
                  if (blog.videoSources) {
                    const videoJsOptions = {
                      autoplay: false,
                      controls: true,
                      height: "100%",
                      sources: [
                        {
                          src: blog.videoSources[0],
                          type: "video/mp4",
                        },
                      ],
                      poster: blog.avatar,
                    };
                    return (
                      <div>
                        <VideoPlayer
                          patientId={patientId}
                          blogId={blogId}
                          sourceType={sourceType}
                          updateVideoAnalysis={updateVideoAnalysis}
                          {...videoJsOptions}
                        />{" "}
                        {/* <video
                          height={'100%'}
                          width={'100%'}
                          src={blog.videoSources[0]}
                          poster={blog.avatar}
                          controls="controls"
                        /> */}
                      </div>
                    );
                  }
                  if (blog.audioSources) {
                    const videoJsOptions = {
                      autoplay: false,
                      controls: true,
                      sources: [
                        {
                          src: blog.audioSources[0],
                          type: "audio/mp3",
                        },
                      ],
                      poster: blog.avatar,
                    };
                    return (
                      <div>
                        <audio
                          style={{
                            width: "100%",
                          }}
                          controls
                          src={blog.audioSources[0]}
                        />
                        {/* <VideoPlayer
                        patientId={patientId}
                        blogId={blogId}
                        updateVideoAnalysis={updateVideoAnalysis}
                        {...videoJsOptions}/>  */}
                      </div>
                    );
                  }
                })()}
                <WhiteSpace size="lg" />{" "}
                <ContentComponent
                  contentHtmlList={contentHtmlList}
                  videoList={videoList}
                  fontSize={fontSize}
                  contentHtml={contentHtml}
                  content={content}
                  blogId={blogId}
                  patientId={patientId}
                  sourceType={sourceType}
                  updateVideoAnalysis={updateVideoAnalysis}
                />
                <DoesItHelpComponent {...this.props} />
              </div>

              <div
                style={{
                  height: "10px",
                  backgroundColor: "#f5f6f8",
                }}
              />
              {isShare || <Correlation {...this.props} />}
            </div>
          </div>
          <Modal
            visible={this.state.showModal}
            transparent
            maskClosable={false}
            onClose={() => {
              this.setState({ showModal: false });
            }}
            title="确定不再关注?"
            footer={[
              {
                text: "取消",
                onPress: () => {
                  this.setState({ showModal: false });
                },
              },
              {
                text: "确认",
                style: { color: "#26C5AB" },
                onPress: () => {
                  this.setState({ showModal: false });
                  mutateSaveFollow({
                    variables: {
                      selfId: patientId,
                      blogId,
                      status: false,
                    },
                  }).then((res) => {
                    const ret = get(res, "data.saveFollow", false);
                    if (ret) {
                      Toast.success("已取消关注", 2);
                      this.props.getFollowState &&
                        this.props.getFollowState.refetch();
                    }
                  });
                },
              },
            ]}
            // wrapProps={{ onTouchStart: this.onWrapTouchStart }}
          ></Modal>
        </main>
      );
    } else {
      return (
        <div
          stlye={{
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          {/* <ActivityIndicator toast text="加载中..." /> */}
          <SkeletonScreen />
        </div>
      );
    }
  }
}

export default Article;



// WEBPACK FOOTER //
// ./src/modules/knowledge/components/article.js